import { CToast } from './CToast.js';
import { CToastBody } from './CToastBody.js';
import { CToastClose } from './CToastClose.js';
import { CToaster } from './CToaster.js';
import { CToastHeader } from './CToastHeader.js';

const CToastPlugin = {
    install: (app) => {
        app.component(CToast.name, CToast);
        app.component(CToastBody.name, CToastBody);
        app.component(CToastClose.name, CToastClose);
        app.component(CToaster.name, CToaster);
        app.component(CToastHeader.name, CToastHeader);
    },
};

export { CToast, CToastBody, CToastClose, CToastHeader, CToastPlugin, CToaster };
//# sourceMappingURL=index.js.map
